import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import watchScroll from './scripts/scrollevent';

import './C5-2-fixed-bottom-bar.scss';

class C52FixedBottomBar extends Component {
	constructor(props) {
		super(props);

		this.state = {
			waiting: false,
		};
	}

	componentDidMount() {
		watchScroll();
	}

	render() {
		const { waiting } = this.state;
		const {
			userLoggedIn,
			sampleCartProducts,
			data: {
				step,
        productCount,
				actions: {
					previous,
					next,
				},
			},
		} = this.props;

		const previousButton = (previous.type !== 'none')
			? (<a href={previous.url} className="C5-2-fixed-bottom-bar__previous btn btn--secondary btn--inverted">{previous.label}</a>)
			: null;

		const nextLabel = (step === 'samples')
			? `${next.label} ${productCount}`
			: next.label;

		let nextButton = null;
		switch (next.type) {
			case 'link':
				nextButton = (
					<a href={next.url} className="C5-2-fixed-bottom-bar__next btn btn--primary btn--inverted">
						{nextLabel}
					</a>
				);
				break;
			case 'submit':

				if (!waiting) {
					nextButton = (
						<button
							type="submit"
							className="C5-2-fixed-bottom-bar__next btn btn--primary btn--inverted"
							onClick={(event) => {
								event.preventDefault();
								document.getElementById('sample-request-form').submit();
								this.setState({ waiting: true });
							}}
						>
							{nextLabel}
						</button>
					);
				} else {
					nextButton = (
						<a href="/" className="C5-2-fixed-bottom-bar__next btn btn--primary btn--inverted" onClick={(event) => { event.preventDefault(); }}>
							<div className="loading">
								<div className="loading__dots">Loading...</div>
							</div>
						</a>
					);
				}
				break;
			default:
				nextButton = null;
				break;
		}

		const bottomBar = (
			<div className="C5-2-fixed-bottom-bar__wrapper">
				<div className="container">
					<div className="row">
						{previousButton}
						{nextButton}
					</div>
				</div>
			</div>
		);

		return (
			<Fragment>
				{ bottomBar }
			</Fragment>
		);
	}
}

C52FixedBottomBar.defaultProps = {
	userLoggedIn: false,
	sampleCartProducts: [],
	data: {
		step: '',
		actions: {
			previous: {
				type: 'none',
				label: null,
				url: null,
			},
			next: {
				type: 'none',
				label: null,
				url: null,
			},
		},
	},
};

C52FixedBottomBar.propTypes = {
	userLoggedIn: PropTypes.bool,
	sampleCartProducts: PropTypes.arrayOf(PropTypes.shape({})),
	data: PropTypes.shape({
		step: PropTypes.string,
		actions: PropTypes.shape({
			previous: PropTypes.shape({
				type: PropTypes.string,
				url: PropTypes.string,
				label: PropTypes.string,
			}),
			next: PropTypes.shape({
				type: PropTypes.string,
				url: PropTypes.string,
				label: PropTypes.string,
			}),
		}),
	}),
};

const mapStateToProps = (state) => {
	return {
		userLoggedIn: state.global.userLoggedIn || false,
		sampleCartProducts: state.sampleCart.products || [],
	};
};

export default connect(mapStateToProps)(C52FixedBottomBar);
